export default ['de', 'en', 'fr', 'nl'];
